/**
 * @fileoverview Header class
 * 
 * @param {string} className - headerのクラス名
 */
export default class PageHeader {
  headerElement?: HTMLElement;

  constructor (className?: string) {
    const targetClassName = className || 'PageHeader';
    const headerElement = document.querySelector(`.${targetClassName}`);

    if (! headerElement) {
      console.error('headerが見つかりませんでした');
      return;
    }
    this.headerElement = headerElement as HTMLElement;

    this.init();
  }

  private init() {
    const headerButton = this.headerElement?.querySelector('.navButton');

    if (! headerButton) return;

    const toggleMenu = (forceClose: boolean = false) => {
      const toggleFlag = !forceClose && !this.headerElement?.classList.contains('open');
      this.headerElement?.classList.toggle('open', toggleFlag);
    };

    headerButton.addEventListener('click', () => {
      toggleMenu();
    });

    window.addEventListener('mousewheel', () => {
      toggleMenu(true);
    }, { passive: true });

    window.addEventListener('touchmove', () => {
      toggleMenu(true);
    }, { passive: true });
  }
};